import React from 'react'

class Attribution extends React.Component{
    render(){
        return(
            <div className="container attribution-container">
                <div className="row">
                    <div className="col-12">
                        <div dangerouslySetInnerHTML={{ __html: this.props.attributionData}}>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Attribution